import React from 'react'

const Masterclasses = ({ masterclasses }) => {
  return (
    <div>
      <h4>Stage</h4>
      <p className="informations" style={{ fontWeight: 'bold' }}>
        Rendez-vous sur le lieu du stage
      </p>
      {masterclasses.map((m, index) => (
        <div key={index}>
          <h4 className="masterclass-title">
            {m.title} - {m.place} - {m.time}
          </h4>
          <p>{m.description}</p>
          <p>
          {m.price != null && `${m.price}`} -{' '}
          {m.link != null && m.link.text != null && (
            <a href={m.link.url}>{m.link.text}</a>
          )}

          </p>
          {/* <p className="masterclass-intervener">Avec {m.intervener}</p> */}
        </div>
      ))}
    </div>
  )
}

export default Masterclasses
